export default __webpack_public_path__ + "static/media/juegoregistro_ganar.c4bb0e73.png";